import {cloneDeep} from 'lodash-es';
import { LocaleService } from 'app/services/locale/locale.service';
import {BookingStatusTypes} from "app/bookingStatusTypes";
import {BookingType} from "app/app.types";
import ConvertJsonToCsv from "app/services/jsonToCsv/jsonToCsv.service";
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import BookingService from "app/services/booking/booking.service";
import DateUtilsService from 'external-services/date-utils-service';
import AdminService from 'external-services/diary-admin-service/admin.service';
import ScheduleLookupService from "external-services/schedule-lookup-service/scheduleLookup.service";

const NS = 'BookingArrivalTimesCtrl'; // jshint ignore:line

export default function BookingArrivalTimesCtrl(
  $q, $log, $window, $rootScope, $scope, $filter, $timeout,
  highChartsService
) {
  "ngInject";

  const vm = this;

  var left = {};
  var arrived = {};
  var dayStartHour = false;
  var dayEndHour = false;
  var allBookings = [];
  var changeTimeout;

  // Public Variables
  const timeZoneId = AdminService.getVenueTimezoneId();
  vm.startDate = DateUtilsService.getClearDate(null, timeZoneId);
  vm.endDate = DateUtilsService.getClearDate(null, timeZoneId);
  vm.startDate.setDate(vm.endDate.getDate() - 7);
  vm.hideDays = true;
  vm.serviceIndex = 0;
  vm.sectionIndex = 0;
  vm.closedToday = false;
  vm.printReport = printReport;
  vm.exportToCsv = exportToCsv;
  vm.loadError = false;
  vm.loading = false;

  load();

  function changeDetected(value, oldValue) {
    if (value !== oldValue) {
      clearTimeout(changeTimeout);
      changeTimeout = setTimeout(getBookings, 300);
    }
  }

  function load() {
    getSchedules().then(function () {
      return getSections();
    }).then(function () {
      return getBookings();
    }).then(function () {
      addListeners();
    }).catch(function (err) {
      console.error(err);
    });
  }

  function addListeners() {
    // Listen
    $scope.$watch('vm.startDate', changeDetected);
    $scope.$watch('vm.endDate', changeDetected);
    $scope.$watch('vm.serviceIndex', filterBookings);
    $scope.$watch('vm.sectionIndex', filterBookings);
  }

  /**
   * Load all schedules
   * And work out the longest day and the services
   */
  function getSchedules() {
    var deferred = $q.defer();
    dayStartHour = false;
    dayEndHour = false;
    var serviceLookUp = {};
    var services = [];
    ScheduleLookupService.getSchedules().then(function (schedules) {
      var totalSchules = schedules.length;
      for (var i = totalSchules - 1; i >= 0; i--) {
        var schedule = schedules[i];
        var totalServices = schedule.services.length;
        for (var s = 0; s < totalServices; s++) {
          var service = schedule.services[s];
          var serviceStartHour = Number(service.startTime.split(':')[0]);
          if (!dayStartHour || serviceStartHour < dayStartHour) {
            dayStartHour = serviceStartHour;
          }
          var serviceEndHour = Math.ceil((Number(service.endTime.split(':')[0]) * 60 + Number(service.endTime.split(':')[1]) + service.bookingDuration) / 60);
          if (!dayEndHour || serviceEndHour > dayEndHour) {
            dayEndHour = serviceEndHour;
          }
          // service
          var serviceKey = service.name.toLowerCase().replace(' ', '-');
          if (isNaN(serviceLookUp[serviceKey])) {
            serviceLookUp[serviceKey] = services.length;
            services.push({
              ids: [service._id],
              serviceKey: serviceKey,
              name: service.name,
              startHour: false,
              endHour: false
            });
          }
          var groupedService = services[serviceLookUp[serviceKey]];
          if (groupedService.ids.indexOf(service._id) === -1) {
            groupedService.ids.push(service._id);
          }
          if (!groupedService.startHour || serviceStartHour < groupedService.startHour) {
            groupedService.startHour = serviceStartHour;
          }
          if (!groupedService.endHour || serviceEndHour > groupedService.endHour) {
            groupedService.endHour = serviceEndHour;
          }
        }
      }
      services.unshift({
        name: "All"
      });
      vm.services = services;
      deferred.resolve();
    });
    return deferred.promise;
  }

  function getSections() {
    var deferred = $q.defer();
    SectionLookupService.getSections().then(function (sections) {
      vm.sections = $filter('orderBy')(sections, 'order');
      vm.sections.unshift({
        name: "All"
      });
      deferred.resolve();
    });
    return deferred.promise;
  }

  /**
   * Load all the bookings in the given range
   */
  function getBookings() {
    left = {};
    arrived = {};
    var deferred = $q.defer();
    BookingService.getBetweenDates(vm.startDate, vm.endDate).then(function (bookings) {
      allBookings = [];
      for (var i = bookings.length - 1; i >= 0; i--) {
        var booking = bookings[i];
        if (booking.status.statusType !== BookingStatusTypes.Cancelled && booking.status.statusType !== BookingStatusTypes.StandbyPending
            && booking.bookingType !== BookingType.StandbyList) {
          // add section id
          var sectionId = (booking.tables && booking.tables.length) ? booking.tables[0].sectionId : null;
          // covert all booking to appaer on the same day
          var startTime = cloneDeep(booking.time);
          startTime.setDate(vm.startDate.getDate());
          startTime.setMonth(vm.startDate.getMonth());
          startTime.setFullYear(vm.startDate.getFullYear());
          // add booking
          allBookings.push({
            startTime: startTime,
            endTime: DateUtilsService.addMinutesToTime(cloneDeep(startTime), booking.duration),
            serviceId: booking.serviceId,
            sectionId: sectionId,
            people: booking.people,
            id: booking._id
          });
        }
      }

      allBookings = $filter('orderBy')(allBookings, 'startTime');
      deferred.resolve();
      // buildChart(allBookings, vm.serviceIndex, vm.sectionIndex);
      filterBookings("", " "); // Call filter to consider section and service
    });
    return deferred.promise;
  }

  function filterBookings(value, oldValue) {
    if (value !== oldValue) {
      var filtedBookings = allBookings.filter(function (booking) {
        if (Number(vm.serviceIndex) !== 0 && vm.services[Number(vm.serviceIndex)].ids.indexOf(booking.serviceId) === -1) {
          // service does not mactc
          return false;
        }
        if (Number(vm.sectionIndex) !== 0 && vm.sections[Number(vm.sectionIndex)]._id !== booking.sectionId) {
          // service does not mactch
          return false;
        }
        return true;
      });
      buildChart(filtedBookings, vm.serviceIndex, vm.sectionIndex);
    }
  }

  function buildChart(allBookings, serviceIndex, sectionIndex) {
    // Filter bookings by sectionIndex
    // Reset Bookings By Section
    var selectedBookings = [];
    // filter bookings by section
    if (sectionIndex === 0) {
      // Build Graph using all data
      selectedBookings = allBookings;
    } else {
      for (var i = 0; i < allBookings.length; i++) {
        var booking = allBookings[i];

        //if (filterBookingsBySection(booking, vm.sectionOptions[sectionIndex].sectionIds)) {
        selectedBookings.push(booking);
        //}
      }
    }
    // Setup the Xaxis
    var graphTotal = setUpGraph(serviceIndex, selectedBookings);
    // Setup Graph
    vm.chartConfig = highChartsService.graphConfig(graphTotal);
    vm.loading = false;
  }

  function setUpXaxis(selectedBookings) {
    // Default to all services to get total range
    // var service = schedule.services[0];
    var startHour = dayStartHour;
    var endHour = dayEndHour;
    if (Number(vm.serviceIndex) !== 0) {
      var service = vm.services[Number(vm.serviceIndex)];
      startHour = service.startHour;
      endHour = service.endHour;
    }

    for (var i = 0; i < selectedBookings.length; i++) {
      var booking = selectedBookings[i];
      if (booking.startTime.getHours() < startHour) {
        startHour = booking.startTime.getHours();
      }
    }

    var openTime = cloneDeep(vm.startDate);
    openTime.setHours(startHour);
    openTime.setMinutes(0);
    var closeTime = cloneDeep(vm.startDate);

    if (endHour > 24) {
      closeTime.setDate(closeTime.getDate() + 1);
      endHour = endHour - 24;
    }
    closeTime.setHours(endHour);
    closeTime.setMinutes(0);
    var xAxisDetails = {
      openTime: openTime,
      closeTime: closeTime,
      totalIntervals: ((DateUtilsService.hoursBetweenDates(openTime, closeTime) * 60) / 15) + 1,
      intervalSpan: parseInt(15)
    };
    return xAxisDetails;
  }

  function resetGraph(name) {
    return {
      type: 'areaspline',
      xAxis: [],
      yAxisTitle: 'Covers',
      seriesName: 'name',
      series: [{
        name: 'Covers In Venue',
        data: [],
        type: 'area',
        lineWidth: 0,
        marker: {
          radius: 0
        },
        step: 'left',
        pointPadding: 0
      }, {
        name: 'Covers Arriving',
        data: [],
        type: 'column',
        lineColor: '#ff4081'
      }],
      graphTitle: name,
      service: name,
    };
  }

  function setUpGraph(serviceIndex, selectedBookings) {
    var xAxisDetails = setUpXaxis(selectedBookings);
    var graphTotal = resetGraph("");

    var bookingInfoIndex = 0;
    var peopleInVenue = 0;
    var time = cloneDeep(xAxisDetails.openTime);
    var span = xAxisDetails.intervalSpan;
    for (var i = 0; i < xAxisDetails.totalIntervals; i++) {
      // Set Minute of the day
      if (i > 0) {
        time = DateUtilsService.addMinutesToTime(time, span);
      }
      // Create booking information object
      var bookingInfo = checkBookings(0, time, DateUtilsService.addMinutesToTime(cloneDeep(time), span), peopleInVenue, selectedBookings);
      bookingInfoIndex = bookingInfo.index;
      peopleInVenue = bookingInfo.coversTotal;

      // Add XAxis Data
      graphTotal.xAxis.push(DateUtilsService.dateToTimeStr12Hour(time));
      // Total Number of Covers
      graphTotal.series[0].data.push(bookingInfo.coversTotal);
      // Get Numbers Covers Arriving
      graphTotal.series[1].data.push(bookingInfo.coversArriving);
    }
    return graphTotal;
  }

  function checkBookings(index, spanStart, spanEnd, peopleInVenue, selectedBookings) {
    var coversArriving = 0;
    var lastMatch = 0;
    for (var i = index; i < selectedBookings.length; i++) {

      var booking = selectedBookings[i];

      // People Arriving
      if (DateUtilsService.isInBetweenDates(booking.startTime, spanStart, spanEnd)) {
        arrived[booking.id] = true;
        coversArriving += booking.people;
        peopleInVenue += booking.people;
        lastMatch = index;
      }
      // People Leaving
      if (DateUtilsService.isInBetweenDates(booking.endTime, spanStart, spanEnd)) {
        left[booking.id] = true;
        peopleInVenue -= booking.people;
        lastMatch = i;
      }
    }
    return {
      coversArriving: coversArriving,
      coversTotal: peopleInVenue,
      index: lastMatch
    };
  }



  // Export To CSV
  function exportToCsv() {
    var reportName = LocaleService.formatDateForFilename(vm.date, 'medium');
    var arrivalTimesArray = [];
    var labels = ['Time', 'Covers Arriving', 'Covers In Venue'];

    var chartData = cloneDeep(vm.chartConfig);
    // Loop over booking totals

    for (var i = 0; i < chartData.xAxis.categories.length; i++) {
      var rowObj = {
        time: chartData.xAxis.categories[i],
        coversArriving: chartData.series[1].data[i],
        coversInVenue: chartData.series[0].data[i]
      };
      arrivalTimesArray.push(rowObj);
    }

    ConvertJsonToCsv.downloadCsv(arrivalTimesArray, labels, reportName);
  }

  // Print button
  function resizeChart() {
    $rootScope.$broadcast('highchartsng.reflow');
  }

  function printReport() {
    vm.printing = true;
    $timeout(function () {
      resizeChart();
      setTimeout(function () {
        window.print();
        printDone();
      }, 200);
    }, 100);
  }

  function printDone() {
    vm.printing = false;
    setTimeout(function () {
      vm.printing = false;
      resizeChart();
    }, 200);
  }
}
